import type { SiteFilterState } from '@/utils/siteUtils';
import { updateRangeOptions } from '@/utils/siteUtils';

interface FilterPanelProps {
  filters: SiteFilterState;
  regions: string[];
  scales: string[];
  onChange: (next: Partial<SiteFilterState>) => void;
  onReset: () => void;
}

interface FilterGroupProps {
  title: string;
  options: string[];
  value: string;
  onSelect: (value: string) => void;
}

function FilterGroup({ title, options, value, onSelect }: FilterGroupProps) {
  return (
    <div className="border-b border-background-200 py-4 last:border-b-0">
      <h4 className="mb-3 text-xs font-semibold uppercase tracking-wide text-foreground-500">{title}</h4>
      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => onSelect('不限')}
          className={`whitespace-nowrap rounded-md px-2.5 py-1.5 text-xs transition-colors ${
            value === '不限'
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          不限
        </button>
        {options.map((option) => (
          <button
            key={option}
            type="button"
            onClick={() => onSelect(option)}
            className={`whitespace-nowrap rounded-md px-2.5 py-1.5 text-xs transition-colors ${
              value === option
                ? 'bg-primary-500 text-background-50'
                : 'bg-background-100 text-foreground-600 hover:bg-background-200'
            }`}
          >
            {option}
          </button>
        ))}
      </div>
    </div>
  );
}

export default function FilterPanel({ filters, regions, scales, onChange, onReset }: FilterPanelProps) {
  return (
    <div>
      <div className="flex items-center justify-between">
        <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
          <i className="ri-filter-3-line text-primary-500"></i>
          筛选条件
        </h3>
        <button
          type="button"
          onClick={onReset}
          className="whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600"
        >
          重置
        </button>
      </div>

      <FilterGroup
        title="地区"
        options={regions}
        value={filters.region}
        onSelect={(value) => onChange({ region: value })}
      />
      <FilterGroup
        title="网站规模"
        options={scales}
        value={filters.scale}
        onSelect={(value) => onChange({ scale: value })}
      />
      <FilterGroup
        title="更新时间"
        options={[...updateRangeOptions].filter((item) => item !== '不限')}
        value={filters.updateRange}
        onSelect={(value) => onChange({ updateRange: value })}
      />
    </div>
  );
}